async function openSpaceExpert(sourceType?: LSCommon.Enums.SavedSearchSourceType) {
   const { default: LiquidSpaceEmbedded } = await import("LiquidSpaceEmbedded");
   LiquidSpaceEmbedded.actions["ls-spaceExpert"]({
      sourceType: sourceType
   });
}

export function useSpaceExpert() {
   return {
      openSpaceExpert
   };
}
